<app-center-container
  [title]="title"
  [showClose]="true"
  (close)="close()">

  <br>
    @if (user) {
      <div>
        {{ 'selectOfficesForUser' | translate }} {{ user.first_name + ' ' + user.last_name }}:
      </div>
    }
    <br>

      @if (form) {
        <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
          <app-input-wrapper
            [control]="form.get('offices')"
            label="{{ 'office' | translate }}">
            <mat-select
              multiple
              class="form_control"
              aria-label="{{ 'office' | translate }}"
              formControlName="offices"
              disableOptionCentering
              panelClass="dropdown">
              @for (office of offices; track office.id) {
                <mat-option [value]="office.id">
                  {{ office.name }}
                </mat-option>
              }
            </mat-select>
          </app-input-wrapper>
          <br>
            <button class="button button--primary form_button" type="submit" [disabled]="!form.valid || !form.dirty">
              <span class="regular">{{ 'done' | translate }}</span>
            </button>
          </form>
        }

      </app-center-container>

      @if (isLoading) {
        <app-loader></app-loader>
      }